import { Component, Vue } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise} from 'axios';
import { LocalStorage } from 'quasar';
import {CONFIG_ENV} from '@/config';
import {ServicesUser} from './modules/ServicesUser';
import user from '@/store/user';
import nomenclatoare from '@/store/nomenclatoare';
import {IUser} from '@/types/iUser';
import MenuApp from './components/MenuApp/MenuApp.vue';
import {ServicesNomCateg} from '@/modules/ServicesNomCateg';
import {ServicesNomTipDoc} from '@/modules/ServicesNomTipDoc';
import {ServicesRegistre} from '@/modules/ServicesRegistre';
import {ServicesDocument} from '@/modules/ServicesDocument';
import iDocumentFastSearch from '@/types/iDocumentFastSearch';
import WorkOnDocument from '@/components/WorkOnDocument/WorkOnDocument.vue';
import moment from 'moment';
import {dateToStringDDMonYYYY} from '@/modules/utils';
/*
var MockAdapter = require('axios-mock-adapter');
var mock = new MockAdapter(axios);
mock.onGet('/loadApp').reply(200, {
    userData:{ username:'Florin Codreanu',
        id:'florin.codreanu@bcr.ro',
        empno:12789}
});
*/

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// axios.defaults.headers.common['X-CSRF-TOKEN'] = '1t6bh0lwh72pv.2k9aurnh5tk44';

@Component({components: {MenuApp, WorkOnDocument}})
export default class App extends Vue {
  public leftDrawerOpen: boolean = false;
  public rightDrawerOpen: boolean = false;
  public showPreviewFileOnDesktop :boolean = false;
  public showPreviewFileOnMobile: boolean = false;
  public nimic: boolean = false;
  public inputFastSearch:any = '';
  public nr_of_recordsFastSearch:number=0;
  public loadingResultForFastSearch:boolean=false;
  public appidForScan: number =0;
  public $refs: any;
  public appidDocToWorkOnIt:number=0;
  public sessionIsValid: boolean = false;
  public optionsFastSearch: { track_creation_date: string; den_registru: string; tip_request: string; appid: number; nume_denumire: string; id_doc: number; den_tip_doc: string }[] = [];
  private userStore = getModule(user);
  private storeNomenclatoare = getModule(nomenclatoare);
  private div_el: HTMLDivElement | undefined;
  private iframe: any;
  constructor() {
    super();
  }

  get user(): IUser {
    return this.userStore.user;
  }

  public getNomenclatoare(){
    const vueInst = this;
    ServicesNomCateg.updateStoreNomCategFromDB();
    ServicesNomTipDoc.updateStoreNomTipDocsFromDB();
    ServicesRegistre.updateStoreNomRegistreFromDB();
  }

  public showOptionsFastSearch() {
    console.log('showOptionsFastSearch');
    //this.$refs.refOptionsFastSearch.show();
  }

  public getDocumentFromFastSearch(params:any){
    const vueInst = this;
    vueInst.$refs.refOptionsFastSearch.hide();
    //console.log('getDocumentFromFastSearch vueInst.inputFastSearch=%o params=%o',vueInst.inputFastSearch,params);
    vueInst.rightDrawerOpen=true;
    vueInst.appidDocToWorkOnIt=params.appid;
    // @ts-ignore
    //document.getElementById('span_pt_simulate_click').click();
    // @ts-ignore
    //document.getElementById('span_pt_simulate_click').click();
  }

  public getOptionSDocumentsFastSearch(pInputSearch:string){
    const vueInst = this;
    vueInst.loadingResultForFastSearch=true;
    vueInst.$refs.refOptionsFastSearch.show();
    console.log('setModel vueInst.pInputSearch=%o',pInputSearch)
    ServicesDocument.FastSearch(pInputSearch).then(presponse=>{
      if(presponse.status=='success'){
        console.log('succes');
        vueInst.nr_of_recordsFastSearch=presponse.nr_of_records;
        vueInst.optionsFastSearch=presponse.rows.map(pDocument=>{
          console.log('acum ciclez');
          const day =moment(pDocument.track_creation_date.substr(0,10), "YYYY-MM-DD");
          const dataDocToDisplayInFastSearch = dateToStringDDMonYYYY(day);
          const tmpTipDoc=vueInst.storeNomenclatoare.NomTipDoc.find(ptipdoc=>{return ptipdoc.id_tip_doc==pDocument.id_tip_doc;});
          const tmpRegistru=vueInst.storeNomenclatoare.NomRegistre.find(pregistru=>{return pregistru.id_registru==pDocument.id_registru;});
          return{
            appid: Number(pDocument.appid),
            id_doc: Number(pDocument.id_doc),
            den_tip_doc: (tmpTipDoc?tmpTipDoc.den_lang_1:''),
            den_registru: (tmpRegistru?tmpRegistru.den_registru_lang_1:''),
            tip_request: pDocument.tip_request,
            nume_denumire: pDocument.nume_denumire,
            track_creation_date: dataDocToDisplayInFastSearch
          }});
      }
      vueInst.$refs.refOptionsFastSearch.show();
      vueInst.loadingResultForFastSearch=false;
    });
  }

public getAppUser() {
    const vueInst = this;
    var $_GET = {};
    if(document.location.toString().indexOf('?') !== -1) {
      var query = document.location
        .toString()
        // get the query string
        .replace(/^.*?\?/, '')
        // and remove any existing hash string (thanks, @vrijdenker)
        .replace(/#.*$/, '')
        .split('&');

      for(var i=0, l=query.length; i<l; i++) {
        var aux = decodeURIComponent(query[i]).split('=');
        // @ts-ignore
        $_GET[aux[0]] = aux[1];
      }
    }
//get the 'index' query parameter
    // @ts-ignore
    if($_GET['u'] && ($_GET['u']=='florin' || $_GET['u']=='bogdan') && $_GET['t'] && $_GET['t'] =='DoarTeste' ){
      ServicesUser.getAppUser('ro').then((presult) => {
        // tslint:disable-next-line:no-console
        console.log('presult=%o', presult);
        // tslint:disable-next-line:triple-equals
        if (presult.status == 'success') {
          vueInst.sessionIsValid=true;
          vueInst.userStore.set_user(presult.user);
          vueInst.getNomenclatoare();
          vueInst.$router.push({name: 'Home'});
        }
      });
    }else{
      vueInst.$router.push({name: 'About'});
    }
  }

  public get widthForDrawerDocument(): number{
    if(this.$q.platform.is.mobile) {return window.innerWidth;}
    else{
      return (window.innerWidth-100);
    }
  }

  public get currentPageTitle(){
    return this.storeNomenclatoare.currentPageTitle;
  }

  public get linkPdfScan():string{
    const vueInst = this;
    return `${CONFIG_ENV.URL_DOCUMENT.pdf_cover}/${vueInst.appidForScan}`;
  }

  public openPreviewForm(pappid: number){
    const vueInst = this;
    vueInst.appidForScan = pappid;
    if(this.$q.platform.is.mobile){
      this.showPreviewFileOnMobile=true;
      // Loaded via <script> tag, create shortcut to access PDF.js exports.
      // @ts-ignore
      var pdfjsLib = window['pdfjs-dist/build/pdf'];

// The workerSrc property shall be specified.
      pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';

      // Asynchronous download of PDF
      var loadingTask = pdfjsLib.getDocument(`${CONFIG_ENV.URL_DOCUMENT.pdf_cover}/${pappid}`);
      loadingTask.promise.then(function(pdf:any) {
        console.log('PDF loaded');

        // Fetch the first page
        var pageNumber = 1;
        pdf.getPage(pageNumber).then(function(page: any) {
          console.log('Page loaded');

          var scale = 1;
          var viewport = page.getViewport({scale: scale});

          // Prepare canvas using PDF page dimensions
          var canvas :any = document.getElementById('canvas-pdf-preview_on_mobile_only');

          var context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          // Render PDF page into canvas context
          var renderContext = {
            canvasContext: context,
            viewport: viewport
          };
          var renderTask = page.render(renderContext);
          renderTask.promise.then(function () {
            console.log('Page rendered');
          });
        });
      }, function (reason: any) {
        // PDF loading error
        console.error(reason);
      });

    }else{//is desktop
      this.showPreviewFileOnDesktop=true;
      ServicesDocument.getPdfCoverDocument(pappid).then((response) => {
        const url = window.URL.createObjectURL(response.data);
        // @ts-ignore
        document.querySelector("iframe").src = url;
      });
    }



  }


  public created(): void {
    var vueInst = this;
    vueInst.getAppUser();
    //@ts-ignore
    vueInst.$eventHub.$on('eventFromChildComponent', (params: any) => {
      console.log('eventFromChildComponent with params=%o', params);
      switch (params.action) {
        case 'show_preview_file': vueInst.openPreviewForm(params.scan_appid);
              break;
      }
    });
  }

  beforeDestroy() {
    //@ts-ignore
    this.$eventHub.$off('eventFromChildComponent');
  }
}
